<template>
  <a-flex justify="space-between" align="center" style="width: 100%">
    <a-flex align="center" gap="small">
      <div class="logo">
        <a-avatar src="/img/logo.svg" shape="square" size="large"/>
        <a-flex align="center" gap="28">
          <a-typography-text>管店宝拓客</a-typography-text>
        </a-flex>
      </div>
      <a-divider type="vertical"/>
      <a-typography-text strong style="font-size: 16px">活动编辑器</a-typography-text>
    </a-flex>

    <a-flex justify="center">
      <a-select v-if="editor.active.preview.branch_id" style="width: 100%; min-width: 300px" size="large" not-found-content="暂无可选的品牌/分支"
                :options="branches" v-model:value="editor.active.preview.branch_id" @change="editor.refresh()"/>
    </a-flex>

    <a-flex style="padding-right: 16px" gap="middle">
      <a-button danger size="large" :icon="h(LogoutOutlined)" @click="$router.push('/activities')"
                :loading="editor.active.status.loading">
        退出
      </a-button>
      <a-button v-if="!editor.meta.publish_at && editor.meta.activity_id" size="large" :icon="h(SaveOutlined)"
                type="default"
                :loading="editor.active.status.loading" @click="editor.save()">
        {{ editor.active.status.lastSaveTS }} 保存
      </a-button>
      <a-button v-if="!editor.meta.publish_at" size="large" :icon="h(SendOutlined)" type="primary"
                :loading="editor.active.status.loading" @click="editor.publish()">发布
      </a-button>
    </a-flex>
  </a-flex>
</template>

<script setup lang="ts">

import {computed, h} from "vue"
import {useRoute} from "vue-router";
import {LogoutOutlined, SaveOutlined, SendOutlined} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";

const editor = useRoute().meta.editor as AEditor;

const branches = computed(() => {
  const arr = [] as unknown[]
  editor.meta.branch_ids.forEach((branch_id: string) => {
    editor.userAgent.meta.brands.forEach(b => {
      const br = b.branches.find(i => i.branch_id === branch_id)
      if (br) arr.push({label: b.name + br.name, value: br.branch_id})
    })
  })
  return arr
})

</script>

<style scoped lang="sass">

.logo
  display: flex
  align-items: center
  justify-content: space-evenly
  width: 160px
  margin-left: 8px

  > .ant-flex
    > span

      &:first-child
        font-size: 20px
        position: relative


</style>